import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ManagementApiService } from 'src/app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { InstanceTypes } from 'src/app/Modules/idms/enums/InstanceType';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import jwt_decode from 'jwt-decode';
import { takeUntil } from 'rxjs/operators';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { NavigateUrlService } from 'src/app/services/navigateurl.service';
import { CustomAvatarService } from 'src/app/services/custom-avatar.service';

@Component({
    selector: 'app-instance-card',
    templateUrl: './instance-card.component.html',
    styleUrls: ['./instance-card.component.scss'],
    standalone: false,
})
export class InstanceCardComponent implements OnInit, AfterViewInit, OnDestroy {
    searchText: string;
    queryParamSubscription: Subscription;
    organizationId: string;
    instances: any = [];
    searchInput = '';
    tempInstances: any;
    SelectedInformate: boolean = false;
    isEditEnabled: boolean = false;
    isAddEnabled: boolean = false;
    isInstanceView: boolean = false;
    destroy$ = new Subject();
    instanceLimit: number;
    instanceList = [];
    targetNavigation: string;
    defaultNavigation: string;
    selectedOrgName: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private managementApiService: ManagementApiService,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private router: Router,
        private globalEmittersService: GlobalEmittersService,
        private userUtilityServices: UserUtilityService,
        private IdmsSharedService: IdmsSharedService,
        private navigateUrlService: NavigateUrlService,
        private customAvatarService: CustomAvatarService
    ) {
        this.instances = [];
        this.instanceLimit = 0;
        this.instanceList = [];
        this.defaultNavigation = 'standardflange';
        this.selectedOrgName = localStorage.getItem('selectedOrganizationName');
    }

    async ngOnInit(): Promise<void> {
        this.isEditEnabled = await this.userUtilityServices.checkUserPermissionDataAndRoute('edit-instance/:id', userActions.Edit);
        this.isAddEnabled = await this.userUtilityServices.checkUserPermissionDataAndRoute('add-instance', userActions.Create);
        this.isInstanceView = await this.userUtilityServices.checkUserPermissionDataAndRoute('view-instance', userActions.View);

        this.queryParamSubscription = this.activatedRoute.queryParamMap.subscribe((queryParams) => {
            this.organizationId = queryParams.get('organizationId');
            this.displayInstanceList();
            this.getOrganizationById();
        });
        this.handleAllSubscriptions();
    }

    handleAllSubscriptions(): void {
        this.globalEmittersService.currentInstanceId.pipe(takeUntil(this.destroy$)).subscribe((instanceId: string) => {
            if (!instanceId) {
                this.deSelectInstance();
            }
        });

        this.globalEmittersService.selectedCalcType.pipe(takeUntil(this.destroy$)).subscribe((calcType: string) => {
            if (calcType) {
                this.targetNavigation = calcType;
            }
        });
    }

    ngAfterViewInit(): void {
        let instanceId = localStorage.getItem('currentInstanceId');
        if (!instanceId) {
            this.deSelectInstance();
        }
    }

    deSelectInstance() {
        var parentDiv = document.querySelector('.organization_container');
        for (let x = 0; x < parentDiv?.children.length; x++) {
            let child = parentDiv?.children[x];
            child?.children[0]?.children[0]?.classList.remove('organization_active');
        }
    }

    // api to get the list of available instances
    getInstancesByOrgId(orgId: string) {
        this.ngxUiLoaderService.start();
        this.managementApiService
            .getInstanceByOrgId(this.organizationId)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (instances) => {
                    this.ngxUiLoaderService.stop();
                    if (instances.success === true) {
                        this.instances = instances.response;
                        this.instanceList = instances.response;
                        this.cd.detectChanges();
                        this.highlightInstance();
                        this.tempInstances = this.instances.slice();
                    } else {
                        this.userUtilityServices.errorModelPopup(instances.message);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                    // TODO :show error toast with message "Error while getting the instances"
                }
            );
    }

    navigateInstanceEdit($event: Event, instanceId: string) {
        $event.preventDefault();
        $event.stopPropagation();
        this.router.navigate([`/management/edit-instance`, instanceId], {
            queryParams: { organizationId: this.organizationId },
        });
    }

    // select the instance
    selectInstance(instance: any) {
        for (let x = 0; x < this.instances.length; x++) {
            let element = document.getElementById(`${this.instances[x].instanceId}`);
            element.classList.remove('organization_active');
        }
        let element = document.getElementById(`${instance.instanceId}`);
        element.classList.add('organization_active');
        this.globalEmittersService.currentInstanceName.next(instance.name);
        this.globalEmittersService.currentInstanceId.next(instance.instanceId);
        this.globalEmittersService.currentInstanceTypeId.next(instance.instanceType.instanceTypeId);
        localStorage.setItem('currentInstanceName', instance.name);
        localStorage.setItem('currentInstanceTypeName', instance.instanceType.name);
        localStorage.setItem('currentInstanceId', instance.instanceId);
        localStorage.setItem('selectedInstanceDetails', JSON.stringify(instance));
        if (instance && instance.instanceAssetType && instance.instanceAssetType.name) {
            localStorage.setItem('currentAssetType', instance.instanceAssetType.name);
        }

        let url = 'commonRoute';

        if (localStorage.getItem('selectedURL') != null || localStorage.getItem('selectedURL') != '') {
            url = localStorage.getItem('selectedURL');
        } else if (instance.instanceType.name.toLowerCase() == 'idms') {
            url = 'idms';
        } else if (instance.instanceType.instanceTypeId == InstanceTypes.ICE) {
            if (this.targetNavigation == 'matrix') {
                url = 'matrix';
            }
        } else {
            url = 'home';
        }
        switch (url) {
            case 'commonRoute':
                this.router.navigate(['informate', this.targetNavigation ? this.targetNavigation : this.defaultNavigation, false]);
                break;
            default:
                this.navigateUrlService.navigateUrl(url);
                break;
        }
    }

    highlightInstance() {
        if (localStorage.getItem('currentInstanceId')) {
            let currentInstanceId = localStorage.getItem('currentInstanceId');
            let element = document.getElementById(currentInstanceId);
            element.classList.add('organization_active');
            this.globalEmittersService.currentInstanceName.next(localStorage.getItem('currentInstanceName'));
            this.globalEmittersService.currentInstanceId.next(localStorage.getItem('currentInstanceId'));
        }
    }

    searchInstance() {
        this.instances = this.tempInstances.filter((item) => {
            return item.name.replace(/\s+/g, '').trim().toLowerCase().includes(this.searchInput.toLowerCase().replace(/\s+/g, '').trim());
        });
    }

    // * display instance list
    async displayInstanceList() {
        let token: any = jwt_decode(localStorage.getItem('msal.accessToken'));
        this.ngxUiLoaderService.start();
        //let userDataResponse = await this.managementApiService.getFullUserDetail(token.oid).toPromise();

        //Calling the getInstancesForDashboard API irrespective of any role as per the new update
        this.getInstancesByOrgId(this.organizationId);
        this.ngxUiLoaderService.stop();

        //if(userDataResponse.response.isSysAdmin){
        //  this.getInstancesByOrgId(this.organizationId);
        //}else{
        //  // userData = this.userUtilityServices.getUserData();
        //  if(userDataResponse.response.organisations.length >= 1){
        //    userDataResponse.response.organisations[0].instances.forEach((ins)=>{
        //      let instanceData = {
        //        instanceId: ins.instanceId,
        //        instanceType: ins.instanceType,
        //        name: ins.name,
        //        logo: ins?.logo
        //      }
        //      this.instances.push(instanceData);
        //    });
        //  }
        //}
        this.cd.detectChanges();
    }

    getOrganizationById() {
        this.globalEmittersService.profileDetails.subscribe((res) => {
            if (res) {
                if (res.isSysAdmin === true) {
                    this.ngxUiLoaderService.start();
                    this.managementApiService
                        .getOrganizationById(this.organizationId)
                        .pipe(takeUntil(this.destroy$))
                        .subscribe((res) => {
                            this.ngxUiLoaderService.stop();
                            if (res.success) {
                                this.instanceLimit = res.response.instanceLimit;
                                // this.selectedOrgName = res.response.name;
                                this.cd.detectChanges();
                            } else {
                                console.warn('Error thrown while calling getOrganizationById ::::: ' + res.message);
                            }
                        });
                }
            }
        });
    }

    getInitials(name: string): string {
        if (!name) return '';
        return this.customAvatarService.getShortInitials(name);
    }

    disableInstance(instance: any) {
        // return !instance?.enabled;
        return !this.userUtilityServices.userData?.isSysAdmin && !instance?.enabled;
    }

    ngOnDestroy(): void {
        this.instanceList = [];
        this.instanceLimit = 0;
        this.queryParamSubscription.unsubscribe();
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
